<div>
  @if(captchaType == 1)
  {
  <div>
    <p>Slide the arrow to the black region along the line.</p>
    <div class="slider-container">
      <input type="range"
             min="0"
             max="100"
             name="slider"
             [(ngModel)]="sliderValue"
             (change)="onSliderChange($event)"
             class="custom-slider" />
      <div class="target-range"
           name="target"
           [style.left.px]="captchaData.targetRangeStart"></div>
    </div>
  </div>
  }
  @if(captchaType == 2 && captchaDataLoaded)
  {
  <div class="drag-captcha">
    <p id="captcha-instruction">Drag the matching item from the top to the bottom.</p>
    <div class="drag-items" role="listbox" aria-labelledby="captcha-instruction">
      @for(item of captchaData.dragItems; track item)
      {
      <div class="drag-item"
           tabindex="0"
           role="option"
           aria-grabbed="false"
           (keydown)="onKeydownDragStart($event, item)"
           (dragstart)="onDragStart($event, item)"
           draggable="true">
        <i class="fa" [ngClass]="item"></i>
      </div>
      }
    </div>
    <div class="captcha-live-region"></div>
    <div class="drop-targets">
      <div class="drop-target"
           tabindex="0"
           role="application"
           aria-label="Drop target"
           (keydown)="onKeydownDrop($event)"
           (drop)="onDrop($event)"
           (dragover)="allowDrop($event)">
        @if(captchaData.dragItemImage)
        {
        <img [src]="captchaData.dragItemImage" alt="An image representing the item to match with the top icons." />
        }
      </div>
    </div>
  </div>
  }
  @if(captchaType == 3)
  {
  <div class="rotate-captcha">
    <p>Rotate all letters to their upright position by clicking on them.</p>
    @for(letter of captchaData.letters; track letter)
    {
    <div class="letter-container">
      <div [style.transform]="'rotate(' + letter.rotation + 'deg)'" (click)="rotateLetter($index)">
        {{ letter.char }}
      </div>
    </div>
    }
  </div>
  }
</div>
